import { put, call, takeLatest, select } from 'redux-saga/effects';
import {
  deleteSinglePendingSupplierJobSuccessAction,
  getPendingSupplierJobsSuccessAction,
  getSinglePendingSupplierJobSuccessAction,
  moderateCreateSinglePendingSupplierJobSuccessAction,
  setPendingSupplierJobsCountAction,
  setPendingSupplierJobsIsLoadingAction,
  updatePendingSupplierJobSuccessAction
} from './Actions';
import { push } from 'react-router-redux';
import {
  errorNotificationFromError,
  newSuccessNotificationAction
} from '../../notifications/Actions';

import { authUserIdSelector } from '../../auth/Selectors';

import { actions } from './Reducer';
import * as api from './Api';

function* getPendingSupplierJobs({ payload }) {
  const defData = {
    // offset: 0,
    // size: 10,
    // sort: "createdAt",
    // dir: "asc",
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [
      {
        jobType: "0"
      }
    ],
    filterCountry: '',
    sort: 'createdAt',
    dir: 'asc'
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingSupplierJobsIsLoadingAction(true));
    const response = yield call(api.getPendingSupplierJobs, body);
    const { data } = response;
    const { content, count } = data;

    yield put(getPendingSupplierJobsSuccessAction(content));
    yield put(setPendingSupplierJobsCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingSupplierJobsIsLoadingAction(false));
  }
}

function* updatePendingSupplierJob({ payload }) {
  const moderatorID = yield select(authUserIdSelector);
  const defData = {
    moderatorID
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingSupplierJobsIsLoadingAction(true));
    yield call(api.updatePendingSupplierJob, body);
    yield put(newSuccessNotificationAction('Job Moderated'));

    yield put(updatePendingSupplierJobSuccessAction(body.moderationRecordID));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingSupplierJobsIsLoadingAction(false));
  }
}

function* getSinglePendingSupplierJob({ payload }) {
  const id = payload;
  try {
    yield put(setPendingSupplierJobsIsLoadingAction(true));
    const response = yield call(api.getSinglePendingSupplierProdcut, id);
    const { data } = response;
    yield put(getSinglePendingSupplierJobSuccessAction(data));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingSupplierJobsIsLoadingAction(false));
  }
}

function* deleteSinglePendingSupplierJob({ payload }) {
  const id = payload;
  try {
    yield put(setPendingSupplierJobsIsLoadingAction(true));
    yield call(api.deleteSinglePendingSupplierProdcut, id);
    yield put(deleteSinglePendingSupplierJobSuccessAction(id));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingSupplierJobsIsLoadingAction(false));
  }
}

function* moderateCreateSinglePendingSupplierJob({ payload, mode }) {
  const id = payload;
  try {
    yield put(setPendingSupplierJobsIsLoadingAction(true));
    if (mode === 'update') {
      const response = yield call(
        api.moderateUpdateSinglePendingSupplierJob,
        id
      );
      const { data } = response;
      yield put(moderateCreateSinglePendingSupplierJobSuccessAction(id));
      yield put(push('/suppliers-moderation/jobs'));
      yield put(newSuccessNotificationAction('Supplier Update Job Moderated'));
    } else {
      const response = yield call(
        api.moderateCreateSinglePendingSupplierJob,
        id
      );
      const { data } = response;
      yield put(moderateCreateSinglePendingSupplierJobSuccessAction(id));
      yield put(push('/suppliers-moderation/jobs'));
      yield put(newSuccessNotificationAction('Supplier Job Moderated'));
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingSupplierJobsIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.GET_PENDING_SUPPLIER_JOBS, getPendingSupplierJobs);

  yield takeLatest(
    actions.UPDATE_PENDING_SUPPLIER_JOB,
    updatePendingSupplierJob
  );
  yield takeLatest(
    actions.GET_SINGLE_PENDING_SUPPLIER_JOB,
    getSinglePendingSupplierJob
  );
  yield takeLatest(
    actions.MODERATE_CREATE_SINGLE_PENDING_SUPPLIER_JOB,
    moderateCreateSinglePendingSupplierJob
  );
  yield takeLatest(
    actions.DELETE_SINGLE_PENDING_SUPPLIER_JOB,
    deleteSinglePendingSupplierJob
  );
}
